const CART_KEY = "camping_guest_shop_cart";

export type CartLine = {
  articleId: string;
  name: string;
  unit: string;
  priceGross: number;
  quantity: number;
  requiresPickupReceipt: boolean;
  pickupDate: string | null;
};

export function loadCart(): CartLine[] {
  if (typeof window === "undefined") return [];
  try {
    const raw = localStorage.getItem(CART_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as CartLine[];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function saveCart(lines: CartLine[]): void {
  localStorage.setItem(CART_KEY, JSON.stringify(lines));
}

export function clearCart(): void {
  localStorage.removeItem(CART_KEY);
}

export function cartTotal(lines: CartLine[]): number {
  return lines.reduce((sum, line) => sum + line.priceGross * line.quantity, 0);
}

export function cartItemCount(lines: CartLine[]): number {
  return lines.reduce((sum, line) => sum + line.quantity, 0);
}
